import script from "./DiscographyView.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscographyView.vue?vue&type=script&setup=true&lang=js"

import "./DiscographyView.vue?vue&type=style&index=0&id=72ae2fc7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ae2fc7"]])

export default __exports__